import * as React from 'react'
import * as clsx from 'clsx'
import { ElementRenderer } from '@components/element-renderer'
import { Spinner } from '@components/loaders/spinner'

interface Props {
  text: React.ReactNode
  wrapperClassName?: string
  iconClassName?: string
  textClassName?: string
  onClick?: (event) => void
  isLoading?: boolean
  loadingText?: string
}

export const IconWithText = ({
  text,
  iconClassName,
  wrapperClassName,
  textClassName,
  onClick,
  isLoading,
  loadingText,
}: Props): JSX.Element => (
  <ElementRenderer
    renderAs={onClick ? 'button' : 'div'}
    className={clsx('d-flex align-items-center', { 'cursor-pointer': !!onClick }, wrapperClassName)}
    onClick={onClick}
  >
    {isLoading ? <Spinner className="spinner--small me-2 text-muted" /> : <i className={clsx(iconClassName)} />}
    <strong className={textClassName}>{isLoading ? loadingText : text}</strong>
  </ElementRenderer>
)
